import { useMemo } from "react"
import PropTypes from "prop-types"
import ModelSelector from "modules/model-selector"
import { Paper } from "@mui/material"
import { useModels } from "resources/models"
import { ERROR, LOADING } from "helpers/data-statuses"
import Loading from "components/loading"
import Error from "components/error"
import { some } from "lodash"
import ErrorModelAccess from "components/error-model-access"

import "./style.scss"

export default function ModelWrapper({ children, modelId, modelName, setModel }) {
  const [models, modelsStatus] = useModels()
  const userHasAccessToModel = useMemo(
    () => !modelId || some(models, model => model.id === modelId),
    [modelId, models],
  )

  if (modelsStatus === LOADING) {
    return <Loading />
  }
  if (modelsStatus === ERROR) {
    return <Error />
  }

  if (!userHasAccessToModel) {
    return <>
      <Paper className="components_model-wrapper">
        <ModelSelector
          warningMessage="Please change the risk model selection"
          disableUnderline
          noSpinner
          alternateLayout
          modelId="no-model-option"
          modelName="Select a different risk model"
          setModel={setModel}
          additionalOption={{
            label: "Select a different risk model",
            value: "no-model-option",
          }}
        />
      </Paper>
      <ErrorModelAccess modelId={modelId} />
    </>
  }

  return <>
    <Paper className="components_model-wrapper">
      <ModelSelector
        disableUnderline
        noSpinner
        modelId={modelId}
        modelName={modelName}
        setModel={setModel}
      />
    </Paper>
    {children}
  </>
}

ModelWrapper.propTypes = {
  modelId: PropTypes.string,
  modelName: PropTypes.string,
  setModel: PropTypes.func.isRequired,
}
